export default function PHP_for() {
  return (
    <div>
      <h1>PHP_for</h1>
    </div>
  );
}
